import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../../api';

export default function BOProductForm() {
  const { standId, productId } = useParams();
  const navigate = useNavigate();
  const isNew = productId === 'new';
  const [form, setForm] = useState({
    nom: '', categorie: '', prix_ttc: '', tva: 20, description: '', options: '', image_url: '', disponible: true,
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!isNew) {
      api.getStandProducts(standId).then(products => {
        const p = products.find(x => x.id === parseInt(productId));
        if (p) setForm({
          nom: p.nom, categorie: p.categorie || '', prix_ttc: p.prix_ttc, tva: p.tva,
          description: p.description || '', options: p.options || '', image_url: p.image_url || '', disponible: p.disponible,
        });
      });
    }
  }, [standId, productId, isNew]);

  const prixHT = form.prix_ttc ? (parseFloat(form.prix_ttc) / (1 + parseFloat(form.tva) / 100)).toFixed(2) : '0.00';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    const data = { ...form, prix_ttc: parseFloat(form.prix_ttc), tva: parseFloat(form.tva) };
    if (isNew) {
      await api.createProduct(standId, data);
    } else {
      await api.updateProduct(productId, data);
    }
    navigate(`/backoffice/${standId}/inventory`);
  };

  const set = (field) => (e) => setForm({ ...form, [field]: e.target.type === 'checkbox' ? e.target.checked : e.target.value });

  const inputClass = "w-full bg-white border border-[#E2D1B8] rounded-lg px-4 py-2.5 text-[#332A1C] focus:border-[#C4673D] focus:outline-none transition";
  const labelClass = "block text-[#8B7355] text-sm font-medium mb-1.5";

  return (
    <div className="max-w-2xl">
      <h1 className="font-serif text-[#332A1C] text-2xl mb-6">
        {isNew ? 'Nouveau produit' : `Modifier : ${form.nom}`}
      </h1>

      <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-sm p-6 space-y-5">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className={labelClass}>Nom du produit *</label>
            <input type="text" value={form.nom} onChange={set('nom')} required
              className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Catégorie</label>
            <input type="text" value={form.categorie} onChange={set('categorie')}
              className={inputClass} />
          </div>
        </div>

        <div className="grid grid-cols-3 gap-4">
          <div>
            <label className={labelClass}>Prix TTC *</label>
            <input type="number" step="0.01" value={form.prix_ttc} onChange={set('prix_ttc')} required
              className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>TVA %</label>
            <select value={form.tva} onChange={set('tva')}
              className={inputClass}>
              <option value={5.5}>5.5%</option>
              <option value={10}>10%</option>
              <option value={20}>20%</option>
            </select>
          </div>
          <div>
            <label className={labelClass}>Prix HT (calculé)</label>
            <input type="text" value={`${prixHT} \u20AC`} readOnly
              className="w-full bg-[#FEFCF8] border border-[#E2D1B8] rounded-lg px-4 py-2.5 text-[#8B7355]" />
          </div>
        </div>

        <div>
          <label className={labelClass}>Description</label>
          <textarea value={form.description} onChange={set('description')} rows={3}
            className={inputClass} />
        </div>

        <div>
          <label className={labelClass}>Options (JSON)</label>
          <input type="text" value={form.options} onChange={set('options')} placeholder='ex: {"taille": ["25cl","50cl"]}'
            className={`${inputClass} placeholder-[#8B7355]/50`} />
        </div>

        <label className="flex items-center gap-2 cursor-pointer">
          <input type="checkbox" checked={form.disponible} onChange={set('disponible')}
            className="h-4 w-4 rounded accent-[#C4673D]" />
          <span className="text-sm text-[#332A1C]">Produit disponible</span>
        </label>

        <div className="flex gap-3 pt-4 border-t border-[#E2D1B8]">
          <button type="submit" disabled={saving}
            className="bg-[#C4673D] text-white px-6 py-2.5 rounded-lg font-bold hover:bg-[#C4673D]/90 transition disabled:opacity-50">
            {saving ? 'Enregistrement...' : 'Enregistrer'}
          </button>
          <button type="button" onClick={() => navigate(`/backoffice/${standId}/inventory`)}
            className="bg-gray-100 text-gray-600 px-6 py-2.5 rounded-lg font-medium hover:bg-gray-200 transition">
            Annuler
          </button>
        </div>
      </form>
    </div>
  );
}
